import React, { useEffect, useState } from "react";
import { supabase } from "@/lib/supabaseClient";

// Flags pilotés depuis l'admin (table public.feature_flags : key/enabled).
const FLAGS = [
  {
    key: "featured_collections",
    title: "Collections en vedette (Landing)",
    desc: "Affiche ou masque le carrousel « Collections en vedette » sur la page d'accueil.",
  },
  {
    key: "advisor_missions_enabled",
    title: "Missions Art Advisor",
    desc: "Active le module Missions (page /expert/missions + kanban client). Le plan donne l'éligibilité ; ce flag contrôle le déploiement.",
  },
];

export default function AdminFeatureToggles() {
  const [flags, setFlags] = useState({});
  const [loading, setLoading] = useState(true);
  const [savingKey, setSavingKey] = useState(null);

  const load = async () => {
    setLoading(true);
    const { data } = await supabase
      .from("feature_flags")
      .select("key, enabled")
      .in("key", FLAGS.map((f) => f.key));
    const map = {};
    (data || []).forEach((r) => { map[r.key] = Boolean(r.enabled); });
    setFlags(map);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const toggle = async (key) => {
    setSavingKey(key);
    const next = !flags[key];
    const { error } = await supabase
      .from("feature_flags")
      .update({ enabled: next, updated_at: new Date().toISOString() })
      .eq("key", key);
    setSavingKey(null);
    if (!error) setFlags((f) => ({ ...f, [key]: next }));
    else alert(error.message || "Erreur sauvegarde");
  };

  return (
    <div className="space-y-3">
      {FLAGS.map((f) => (
        <div key={f.key} className="p-4 border rounded-xl">
          <div className="flex items-center justify-between gap-4">
            <div>
              <div className="font-semibold">{f.title}</div>
              <div className="text-sm text-gray-600">{f.desc}</div>
            </div>
            <button
              onClick={() => toggle(f.key)}
              disabled={loading || savingKey === f.key}
              className={`px-4 py-2 rounded-lg ${flags[f.key] ? "bg-green-600 text-white" : "bg-gray-200 text-gray-900"}`}
            >
              {loading ? "…" : flags[f.key] ? "ON" : "OFF"}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
